// extracted by mini-css-extract-plugin
export default {"v-save-for-later-gutter":"6px","v-product-image-height-to-width-percent":"calc((1 / (87 / 111)) * 100%)","productTile":"productTile_hKUcl"};